<template>
  <div class="section-main__warp visitor-wrap">
    <ioc-table
      ref="crud"
      v-model="account"
      :data="tableData"
      :option="option"
      :page="page"
      @search-change="handleSearchChange"
      @search-reset="handleSearchReset"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      @refresh-change="refreshChange"
      @selection-change="handleSelectionChange"
    >
      <template slot="search_createTime">
        <div>
          <el-date-picker
            @change="handleTimeChange"
            type="datetimerange"
            v-model="searchTime"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
          <!-- <span style="padding: 0 5px">至</span> -->
          <!-- <el-date-picker
            type="datetime"
            placeholder="请选择结束时间"
            v-model="searchParams.endTime"
            default-time="23:59:59"
            style="width: 182px"
          ></el-date-picker> -->
        </div>
      </template>
      <template slot="fileCode" slot-scope="scope">
        <img
          :src="imgPath(scope.row.fileCode)"
          @click="showViewer(imgPath(scope.row.fileCode), $event)"
          onerror="this.src='/images/theme/newDark/default.png'"
          style="height: 25px; width: 50px; cursor: pointer"
        />
      </template>
      <template slot="idCardFileCode" slot-scope="scope">
        <img
          :src="imgPath(scope.row.idCardFileCode)"
          @click="showViewer(imgPath(scope.row.idCardFileCode), $event)"
          onerror="this.src='/images/theme/newDark/default.png'"
          style="height: 25px; width: 50px; cursor: pointer"
        />
      </template>
      <template slot="menuLeft">
        <el-button
          type="primary"
          v-auth="'/access/visitorRecord:export'"
          @click="exportDocument"
          icon="el-icon-download"
          >{{ exportDisabled ? "正在导出" : "导出" }}</el-button
        >
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="详情"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-Detail"
            @click="handleView(scope.row, scope.index)"
          ></el-button>
        </el-tooltip>
      </template>
      <!-- 姓名点击跳转详情页面 -->
      <template slot="name" slot-scope="scope">
        <el-button type="text" @click="handleView(scope.row, scope.index)">{{
          scope.row.name
        }}</el-button>
      </template>
    </ioc-table>
    <detail-dialog ref="detailDialog"></detail-dialog>
  </div>
</template>
<script>
import { Dic, Bus, Dates } from "$utils";
import { api } from "../api";
import utils from "@src/common/utils";
import tableOption from "../const/record";
import detailDialog from "../components/details-dialog";
export default {
  components: { detailDialog },
  data() {
    return {
      exportDisabled: false,
      tableData: [],
      option: tableOption(),
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      account: {},
      detailData: {},
      getTimeOut: null,
      searchTime: [],
      searchParams: {
        status: "",
        name: "",
        plateCode: "",
        beginTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
    };
  },
  beforeDestroy() {
    this.getTimeOut && clearTimeout(this.getTimeOut);
  },
  mounted() {
    this.getList();
  },
  created() {},
  methods: {
    handleTimeChange(data) {
      console.log(data, ">>>>>data");
      if (data && data.length > 0) {
        this.searchParams.beginTime = data[0];
        this.searchParams.endTime = data[1];
      }
    },
    handSetTime() {
      if (this.getTimeOut) {
        clearTimeout(this.getTimeOut);
      }
      this.getTimeOut = setTimeout(() => {
        this.getList();
      }, 1000 * 60 * 2);
    },
    imgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    showViewer(src, e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    statusFormatter(data) {
      switch (data.status * 1) {
        // 1:待接待人审批,2:接待人审批通过,待部门负责人审批3:部门负责人审批通过,待区域负责人审批4:区域负责人同意5:拒绝'
        case 1:
          return "待审批";
        case 2:
          return "已通过";
        case 3:
          return "已拒绝";
        default:
          return data.status;
      }
    },
    isFactoryFormatter(data) {
      switch (data * 1) {
        //
        case 0:
          return "厂内";
        case 1:
          return "厂外";
        default:
          return data;
      }
    },
    //导出
    exportDocument() {
      const params = {
        status: this.searchParams.status ? this.searchParams.status : "", // 4 同意 5 拒绝
        name: this.searchParams.name ? this.searchParams.name : "",
        beginTime: this.searchParams.beginTime
          ? Dates.format(this.searchParams.beginTime)
          : "", //'开始时间',
        endTime: this.searchParams.endTime
          ? Dates.format(this.searchParams.endTime)
          : "", //结束
        plateCode: this.searchParams.plateCode
          ? this.searchParams.plateCode
          : "",
      };
      // 兼容IE
      this.exportDisabled = true;
      this.$fetchDownLoad(api.exportVisitorApplyRecordList, params, {
        responseType: "arraybuffer",
      }).then((response) => {
        const content = response.data;
        const blob = new Blob([content], { type: "application/zip" });
        const fileName =
          "访客预约记录信息" +
          Dates.format(Date.now(), "yyyyMMddHHmmssms") +
          ".zip";
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
        this.exportDisabled = false;
      });
    },
    // 重置列表
    handleSearchReset() {
      this.searchParams = {};
      this.searchTime = [];
      this.getList();
    },
    // 获取预约记录
    getList() {
      const params = {
        status: this.searchParams.status ? this.searchParams.status : "", // 4 同意 5 拒绝
        beginTime: this.searchParams.beginTime
          ? this.searchParams.beginTime
          : "", //'开始时间',
        endTime: this.searchParams.endTime ? this.searchParams.endTime : "", //结束
        name: this.searchParams.name ? this.searchParams.name : "",
        plateCode: this.searchParams.plateCode
          ? this.searchParams.plateCode
          : "",
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
      };
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.queryVisitorApplyRecordList, params).then((response) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        if (!response.success) {
          this.$message({
            message: response.msgContent,
            type: "error",
            duration: 2000,
          });
          return;
        }
        this.handSetTime();
        this.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.page.total = response.returnObj ? response.returnObj.total : 0;
        this.$refs.crud.selectClear();
      });
    },
    refreshChange(page) {
      this.searchParams = {};
      this.getList(page);
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.refreshChange(this.page);
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.refreshChange(this.page);
    },
    handleSearchChange(param) {
      let tempObj = {};
      tempObj.beginTime = this.searchParams.beginTime;
      tempObj.endTime = this.searchParams.endTime;
      this.searchParams = Object.assign({}, param);
      this.searchParams.beginTime = tempObj.beginTime;
      this.searchParams.endTime = tempObj.endTime;
      this.getList();
    },
    handleSelectionChange(items) {
      this.checkedAccounts = items.map((item) => {
        return item.workGroupCode;
      });
    },
    handleView(row, index) {
      this.$refs.detailDialog.open(row.appointmentCode);
    },
  },
};
</script>
<style lang="scss">
@import "../style/visitorRecord.scss";
</style>
